export default __webpack_public_path__ + "static/media/g5.d67725fa.jpg";